import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { Constants } from '../config/constant';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MixpanelService } from './mixpanel.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private _const: Constants,
    private snackbar: MatSnackBar,
    private mixpanel: MixpanelService
  ) {}

  private logoutData(res: any) {
    return res.body;
  }

  private extractData(res: any) {
    const helper = new JwtHelperService();
    let body = res.body;
    if (body.status) {
      sessionStorage.setItem('access', body.data.access);
      sessionStorage.setItem('refresh', body.data.refresh);
      //  To decode token
      //  const decodedToken = helper.decodeToken(body.access);
      //  const expirationDate = helper.getTokenExpirationDate(body.access);
      const isExpired = helper.isTokenExpired(body.data.access);
      sessionStorage.setItem('isUserLoggedIn', isExpired ? 'false' : 'true');
      if (!isExpired) {
        this.logout;
      }
    }
    return body;
  }

  private handleErrorObservable = (error: any) => {
    if (error.error.message) {
      this.snackbar.open(error.error.message, undefined, {
        duration: 5000,
        panelClass: 'failure',
      });
    } else {
      this.snackbar.open(
        'Oops! Something went wrong, Please Try again later...',
        undefined,
        {
          duration: 5000,
          panelClass: 'failure',
        }
      );
    }
    return throwError(error);
  };

  login(userID: any, pwd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http
      .post(
        `${this._const.API}/login`,
        { username: userID, password: pwd },
        { observe: 'response', headers: httpOptions.headers }
      )
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  ssoLogin() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }),
    };
    return this.http
      .get(`${this._const.API}/sso/auth`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(
        tap((response: HttpResponse<any>) => {
          if (response.status === 303) {
            const redirectionUrl = response.headers.get('Location');
            if (redirectionUrl) {
              window.location.href = redirectionUrl;
            } else {
              throw new Error('Redirection URL not found in response headers.');
            }
          }
        }),
        map((response: HttpResponse<any>) => this.extractData(response)),
        catchError(this.handleErrorObservable)
      );
  }

  ssoDemo(email) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http
      .get(
        `https://shark-dev-ws.bigyellowfish.io/api/v1/usermanagement/user/${email}?returnURL=${window.location.href}`,
        { observe: 'response', headers: httpOptions.headers }
      )
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  logout() {
    this.mixpanel.track('button_click', {
      page: 'Logout',
      category: 'Auth',
      button: 'Logout',
    });
    this.mixpanel.track('page_view', {
      page: 'Logout',
      category: 'Auth',
      button: '-',
    });
    this.mixpanel.reset();
    let refresh = sessionStorage.getItem('refresh');
    let access = sessionStorage.getItem('access');
    sessionStorage.clear();
    this.router.navigate(['../login']);
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${access}`,
      }),
    };
    return this.http
      .post(
        `${this._const.API}/logout`,
        { refresh_token: refresh },
        { observe: 'response', headers: httpOptions.headers }
      )
      .pipe(catchError(this.handleErrorObservable), map(this.logoutData));
  }
}
